export interface CurrentRegimenCurveContract extends Record<string, unknown> {
  time: number[];
  concentration: number[];
}

const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null
);

export const resolveCurrentRegimenCurve = (result: unknown): CurrentRegimenCurveContract | null => {
  if (!isRecord(result)) return null;
  const originalRegimen = isRecord(result.original_regimen) ? result.original_regimen : null;
  const curve = result.current_regimen_curve ?? originalRegimen?.simulation_data;
  if (!isRecord(curve)) return null;
  return Array.isArray(curve.time)
    && Array.isArray(curve.concentration)
    && curve.time.length > 1
    && curve.time.length === curve.concentration.length
    ? curve as CurrentRegimenCurveContract
    : null;
};

export const hasPosteriorPredictionBand = (curve: unknown): boolean => {
  if (!isRecord(curve) || !Array.isArray(curve.time) || curve.time.length === 0) return false;
  const timeLength = curve.time.length;
  const hasBand = (lowerKey: string, upperKey: string) => (
    Array.isArray(curve[lowerKey])
    && Array.isArray(curve[upperKey])
    && curve[lowerKey].length === timeLength
    && curve[upperKey].length === timeLength
  );
  return hasBand('concentration_p025', 'concentration_p975')
    || hasBand('concentration_p05', 'concentration_p95');
};
